import { combineReducers } from 'redux'
import messages from './messages'
import unreadMessages from './unreadMessages'
import messageFilters from './messageFilters'
import loadingMessages from './loadingMessages'
import deferredMessages from './deferredMessages'

/**
 * Chat state for user.
 * @param state Current state
 * @param action Action to do
 */
const chat = combineReducers({
  messages,
  unreadMessages,
  messageFilters,
  loadingMessages,
  deferredMessages,
})

export default chat
